<template>
  <v-container v-if="this.condition()" fluid>

     <v-row dense>
      <v-col cols="12">
        <v-card v-if="this.condition()">
          <v-card-title>Contact</v-card-title>
          <v-card-text>
            <v-simple-table dense width="100%" id="tabadress">
            <tbody>
             <tr>
                <td > <v-icon v-on:click="scrollMeTo('blocdirigeants')">mdi-account</v-icon></td>

               <td>
                    {{dirigeant}}
                </td>
              </tr>


              <tr
                v-for="(item, i) in tels"
                :key="'t-'+i"
            >
              <td > <v-icon>mdi-phone</v-icon></td>
               <td>
                  {{item}}
                </td>
            </tr>
               <tr
                v-for="(item, i) in emails"
                :key="'e-'+i"
            >
              <td > <v-icon>mdi-at</v-icon></td>
               <td>
                     <a :href="`mailto:${item}`">{{item}}</a>
                </td>
            </tr>
               <tr
                v-for="(item, i) in site_webs"
                :key="'s-'+i"
            >
              <td > <v-icon>mdi-web</v-icon></td>
               <td>
                    <a :href="`${item}`" target="_blank">{{item}}</a>
                </td>
            </tr>




            </tbody>
            </v-simple-table>


            </v-card-text>
        </v-card>
      </v-col>
    </v-row>


  </v-container>

</template>


<script>


export default {
  name: 'EtabAdresse',
  components: {
  },
  computed: {
    emails: function () {
      return this.$store.getters.getbloc("contact", "donnees", "emails", null, "valeur")
    },
     tels: function () {
      return  this.$store.getters.getbloc("contact", "donnees", "telephones", null, "valeur")
    },
     site_webs: function () {
      return  this.$store.getters.getbloc("contact", "donnees", "site_webs", null, "valeur")
    },
    contact: function () {
      return this.$store.getters.getbloc("contact", "donnees")
    },

    dirigeant: function () {
      var dirigeants =  this.$store.getters.getbloc("contact", "donnees", "executive")

      if (dirigeants != null && dirigeants.valeur !=null && dirigeants.valeur.length>0) {
        var dirigeantstrouve =  dirigeants.valeur.filter(dir => ["Gérant","Président","Directeur Général","Propriétaire"].includes(dir.statut_executive) );

        if (dirigeantstrouve.length>0) {
          return dirigeantstrouve[0]["firstname_executive"]+" "+  dirigeantstrouve[0]["name_executive"]
        } else {
          return null
        }
      } else {
        return null
      }
    },
  },

  methods: {
    condition() {
      return this.$store.getters.condition("contact", "donnees")
    },
  }
};
</script>